import { render, staticRenderFns } from "./rejectedList.vue?vue&type=template&id=ea5b5be2"
import script from "./rejectedList.vue?vue&type=script&lang=js"
export * from "./rejectedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports